export default __webpack_public_path__ + "static/media/williamblair.e33ffd40.png";